<template lang="pug">
  .credit-card
    .alert.alert-danger(v-if="lodingCardFailed") Card Loading Failed
    .pos-r.of-h(v-else, :id="cardType")
      div(v-if="ribbonVar===4")
        .ribbon Allow Over Budget
      div(v-if="ribbonVar===3")
        .ribbon-deactivated De-Activated
      div(v-if="ribbonVar===1")
        .ribbon-blocked Replaced
      div(v-if="ribbonVar===2")
        .ribbon-shipping Shipped
      div(v-if="ribbonVar===5")
        .ribbon-ordered Ordered
      div(v-if="card.isHighLimitCard===true")
        .ribbon-highlimitcard Hight Limit Card
      el-button(
        type="text"
        v-loading="lodingCard"
        @click="btnClicked"
      ).p-0.text-white.text-left.shadow-sm.of-h.d-block.w-100
        template(v-if="isPhysicalCard")
          img(:src="branding.physicalImg").w-100
          .pin.pin-xy.p-2.text-capitalize
            svg(
              viewBox="0 0 364 230"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              fill="currentColor"
            ).d-block.mx-auto.pin.pin-xy
              template(v-if="showMarqeta")
                text(font-size="7.5" x="151" y="165") CVV
                text(font-size="7.5" x="215" y="165") Valid Thru

              template(v-else)
                text(font-size="25.6" x="35" y="155").fw-b
                  | XXXX&nbsp;&nbsp;XXXX&nbsp;&nbsp;XXXX&nbsp;&nbsp;
                  | {{ card.last_four === 0 ? 'XXXX' :card.last_four }}

              text(font-size="20" x="35" y="210")
                | {{ card.nameOnCard }}

              use(xlink:href='#logo-visa' x="273" y="178" width="80" height="25.836")
              text(font-size="11" x="295" y="217") Commercial

        template(v-if="isVirtualCard")
          img(:src="branding.virtualImg").w-100
          .pin.pin-xy.p-2.text-capitalize
            svg(
              viewBox="0 0 364 230"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              fill="currentColor"
            ).d-block.mx-auto.pin.pin-xy.text-white
              template(v-if="!showMarqeta")
                text(font-size="24" x="8" y="120").pan
                  | XXXX&nbsp;&nbsp;XXXX&nbsp;&nbsp;XXXX&nbsp;&nbsp;{{ card.last_four }}
                text(font-size="18" x="8" y="162.5").cvv XXX
                text(font-size="18" x="78" y="162.5").exp XX/XX

              text(font-size="15" :x="branding.virtualCardTextX" y="24") Virtual Card
              text(font-size="9" x="8" y="72") Customer Service +1 (415) 625-3611
              text(font-size="9" x="8" y="95") ACCOUNT NUMBER
              text(font-size="7.5" x="8" y="140") Security Code
              text(font-size="7.5" x="78" y="140") Valid Thru
              //text(font-size="9" x="8" y="197") LIMITED USE
              //text(font-size="8.1" x="8" y="210")
              //  | This card is issued by Sutton Bank, Member FDIC, pursuant to a license from
              //  | Visa U.S.A Inc.
              //text(font-size="8.1" x="8" y="220")
              //  | This SpendHub card is powered by Marqeta.
              use(xlink:href='#logo-visa' x="273" y="158" width="80" height="25.836")
              text(font-size="11" x="295" y="197") Commercial

        template(v-if="showMarqeta")
          #copy-pan-container.copy-icon
            img(
              alt='Copy card number'
              src='@/assets/copy-icon.png',
            )

        template(v-if="showMarqeta")
          #mq-card-cvv.d-flex.align-items-center
            // Marqeta card # goes here

          #mq-card-exp
            // Marqeta card # goes here

          #mq-card-pan
            // Marqeta card # goes here


    div(v-if="(!showMarqeta && showMerchant)")
      div(v-if="isVirtualCard").d-flex.align-items-center.mt-2
        .mr-11(v-if='card.Merchant[0]')
          div(v-if='card.Merchant[0].parent')
            img(v-if='card.Merchant[0].parent.logo'
              :src='card.Merchant[0].parent.logo'
            ).size-32.rounded-circle.shadow-sm
          div(v-else)
            img(v-if='card.Merchant[0].logo'
              :src='card.Merchant[0].logo'
            ).size-32.rounded-circle.shadow-sm
            img(v-else
              :src='require(`@/assets/images/merchants/google.png`)'
            ).size-32.rounded-circle.shadow-sm
        div
          .flex-1.lh-n(v-if='card.Merchant[0] && card.Merchant[0].parent')
            .fs-12(v-if='card.Merchant[0].parent') {{ card.Merchant[0].parent.name }}
            .fs-12(v-else) Merchant
            .fs-13
              | {{ card.usedbudget | toUSD }}
              //- removed as per SH-66
              //- added back by SHUB-212
              span.px-1.text-muted •
              | {{ !card.isOneTime ? 'Recurring' : 'One Time' }}
              span.px-1.text-muted •
              | {{ getActiveState(card.state) }}
          .flex-1.lh-n(v-else)
            .fs-12(v-if='card.Merchant[0]')
              | {{ card.Merchant[0].name }}
              span.px-1.text-muted(v-if='card.Merchant.length>1')
                | +{{ card.Merchant.length -1 }}

            .fs-12(v-else) Merchant
            .fs-13
              | {{ card.usedbudget | toUSD }}
              //- removed as per SH-66
              //- added back by SHUB-212
              span.px-1.text-muted •
              | {{ !card.isOneTime ? 'Recurring' : 'One Time' }}
              span.px-1.text-muted •
              | {{ getActiveState(card.state) }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import companyBranding from '@/mixins/companyBranding';
import SpendHubText from '@/components/logos/SpendHubText.vue';
import SpendHubLogo from '@/components/logos/SpendHubLogo.vue';

export default {
  name: 'CreditCard',

  components: {
    SpendHubText,
    SpendHubLogo,
  },

  mixins: [companyBranding],

  props: {
    otherSettings: {
      default: () => { },
      type: Object,
    },
    isOverbudget: {
      default: () => { },
      type: Object,
    },
    card: {
      default: () => { },
      type: Object,
    },
    employee: {
      default: () => { },
      type: Object,
    },
    isVirtualCard: {
      default: false,
      type: Boolean,
    },
    isPhysicalCard: {
      default: false,
      type: Boolean,
    },
    isPhysicalCardEx: {
      default: false,
      type: Boolean,
    },
    showMarqeta: {
      default: false,
      type: Boolean,
    },
    showMerchant: {
      default: true,
      type: Boolean,
    },
  },

  data() {
    return {
      ribbonVar: 0,
      isBlock: false,
      isAOB: false,
      isActive: false,
      lodingCard: false,
      lodingCardFailed: false,
      itemToken: null,
    };
  },

  computed: {
    ...mapGetters('cards', ['userAccessToken']),
    cardType() {
      if (this.showMarqeta) {
        return this.isVirtualCard ? 'virtual-card-container' : 'physical-card-container';
      }
      return '';
    },
  },

  watch: {
    isOverbudget(value) {
      this.isBlock = value.state;
      if (value.is === true) {
        this.isAOB = true;
      }

      if (value.is === false) {
        this.isAOB = false;
      }

      if (value.isActive === true) {
        this.isActive = true;
      }
      if (value.isActive === false) {
        this.isActive = false;
      }

      this.ribbonVar = 0;
      if (this.isBlock === 'BLOCK') {
        this.ribbonVar = 1;
      } else if (this.card.shippingInfo && this.card.shippingInfo.recordStatus === 0) {
        this.ribbonVar = 2;
      } else if (this.card.shippingInfo && this.card.shippingInfo.recordStatus === 3) {
        this.ribbonVar = 5;
      } else if (this.isActive) {
        this.ribbonVar = 3;
      } else if (this.isAOB) {
        this.ribbonVar = 4;
      }
    },
  },

  mounted() {
    if (this.showMarqeta) this.initMarqeta();
  },

  methods: {
    ...mapActions('cards', ['getCateAccessToken']),

    getActiveState(value) {
      if (value === 'ACTIVE') {
        return 'Active';
      }
      return 'Inactive';
    },

    btnClicked() {
      this.$emit('cardClicked');
    },

    copyPan() {
      console.log('Message');
      this.$message({
        message: 'Account number copied.',
        type: 'success',
      });
      try {
        // eslint-disable-next-line no-undef
        // marqeta.copyToClipboard('mq-card-pan');
        // eslint-disable-next-line no-undef
        // marqeta.copyToClipboard('mq-card-pan');
      } catch (e) {
        console.log('e', e);
      }
    },

    async initMarqeta() {
      // ask for Client Access Token;
      await this.getCateAccessToken({ cardToken: this.card.token });

      if (this.userAccessToken.clientAccessToken.error) {
        this.$message({
          message: this.userAccessToken.clientAccessToken.error,
          type: 'error',
        });
      } else {
        await this.generatePan(this.userAccessToken.clientAccessToken.token);
      }
    },

    runMarqeta(token) {
      // marqeta script will be loaded from CDN
      /* eslint-disable-next-line no-undef */
      marqeta.destroy();
      /* eslint-disable-next-line no-undef */
      marqeta.bootstrap({
        clientAccessToken: token,
        integrationType: 'custom',
        containerId: this.cardType,
        showPan: {
          cardPan: {
            domId: 'mq-card-pan',
            format: true,
            styles: {
              span: {
                background: 'transparent',
                color: '#fff',
                'font-family': 'Arial, sans-serif',
                'font-size': '23px',
              },
            },
          },
          /* JP Edit */
          copyCardPan: {
            domId: 'copy-pan-container',
            mode: 'transparent',
            onCopySuccess: () => {
              this.copyPan();
            },
            onCopyFailure: (error) => {
              console.error(error);
            },
          },
          /* JP Edit */
          cardExp: {
            domId: 'mq-card-exp',
            format: true,
            styles: {
              span: {
                background: 'transparent',
                color: '#fff',
                'font-family': 'Arial, sans-serif',
                'font-size': '17px',
              },
            },
          },
          cardCvv: {
            domId: 'mq-card-cvv',
            styles: {
              span: {
                background: 'transparent',
                color: '#fff',
                'font-family': 'Arial, sans-serif',
                'font-size': '17px',
              },
            },
          },
        },
        callbackEvents: {
          onSuccess: () => {
            this.lodingCard = false;
          },
          onFailure: () => {
            this.lodingCard = false;
            this.lodingCardFailed = true;
          },
        },
      });
    },

    runMarqetaHasError(plugin) {
      this.lodingCard = false;

      this.$message({
        message: 'Unable to load card information.',
        type: 'error',
      });

      document.head.removeChild(plugin);
    },

    async generatePan(token) {
      this.lodingCard = true;
      // fetch URL from .env file

      const MARQETA_URL = process.env.VUE_APP_MARQETA_JS_URL;
      // if script does not exist only then append marqeta script to DOM
      // Remove DOM and createNew one
      if (!document.getElementById('marqeta-script')) {
        const plugin = document.createElement('script');
        plugin.setAttribute(
          'src',
          MARQETA_URL,
        );
        plugin.setAttribute('id', 'marqeta-script');
        plugin.async = true;
        plugin.addEventListener('load', () => this.runMarqeta(token), false);
        plugin.addEventListener('error', () => this.runMarqetaHasError(plugin), false);
        await document.head.appendChild(plugin);
      } else {
        // runs if script is already loaded DOM
        this.runMarqeta(token);
      }
    },
  },
};
</script>
